module.exports = __webpack_public_path__ + "static/media/Laugo_13.77e43438.jpg";